

exports.__esModule = true;
exports.$xoPinSetupPageRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPinSetupPageRoute = exports.$xoPinSetupPageRoute = _index.$Route.extend('$xoPinSetupPageRoute', {
    path: 'pinSetup',
    directive: _directive2['default'],
    titleContent: 'Wallet Pin Setup',
    trackingData: {
        fptiState: 'pinSetup'
    },

    children: []
});

angular.value("$xoPinSetupPageRoute", $xoPinSetupPageRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pin-setup/route.js
// module id = ./pages/xo-pin-setup/route.js
// module chunks = 0